"use client";

// PublicTopBar — minimal header for public pages (/people etc.)
// No session-dependent shell. Only brand link + auth entry.

import Link from "next/link";
import Image from "next/image";
import SignInEntryButton from "@/components/auth/SignInEntryButton";

export default function PublicTopBar() {
  return (
    <header
      style={{
        height: 48,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 16px",
        borderBottom: "1px solid #e8e8e8",
        background: "#fff",
      }}
    >
      <Link href="/" aria-label="ホーム" className="flex items-center opacity-70 hover:opacity-100 transition-opacity">
        <Image src="/kataruta-mark.png" alt="KATARUTA" width={28} height={28} className="object-contain" />
      </Link>
      <SignInEntryButton />
    </header>
  );
}
